import Vue from "vue";
import Router from "vue-router";
import AuthLayout from "@/layouts/auth";
import RouterLayout from "@/layouts/router";
import AppLayout from "@/layouts/fhb";
import StandardLayout from "@/layouts/standard";
import SessionLayout from "@/layouts/session";
import store from "@/store";
Vue.use(Router);

const router = new Router({
  base: process.env.BASE_URL,
  mode: "history",
  linkExactActiveClass: "active",
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      component: StandardLayout,
      children: [
        {
          path: "/",
          meta: {
            title: "PonyEngine Home"
          },
          component: () => import("./views/site/home")
        },
        {
          path: "/apps/viewer",
          component: () => import("./views/site/apps/viewer")
        },
        {
          path: "/pricing",
          component: () => import("./views/site/pricing")
        },
        {
          path: "/survey",
          component: () => import("./views/site/forms/survey")
        },
        {
          path: "/present/:slug",
          meta: {
            title: "Presentation"
          },
          component: () => import("./views/site/present")
        },
        {
          path: "/policy",
          meta: {
            title: "Policy"
          },
          component: RouterLayout,
          children: [
            {
              path: "privacy",
              component: () => import("./views/site/policy/privacy")
            },
            {
              path: "terms",
              component: () => import("./views/site/policy/terms")
            },
            {
              path: "data",
              component: () => import("./views/site/policy/data")
            },
            {
              path: "care",
              component: () => import("./views/site/policy/care")
            },
            {
              path: "subscription-services-agreement",
              component: () => import("./views/site/policy/ssa")
            }
          ]
        },
        {
          path: "/intro",
          meta: {
            title: "Policy"
          },
          component: RouterLayout,
          children: [
            {
              path: "sessions",
              component: () =>
                import("./views/site/introducing/sessions/landing")
            },
            {
              path: "iona",
              component: () => import("./views/site/policy/terms")
            },
            {
              path: "heartbeatcentral",
              component: () => import("./views/site/policy/data")
            },
            {
              path: "care",
              component: () => import("./views/site/policy/care")
            },
            {
              path: "subscription-services-agreement",
              component: () => import("./views/site/policy/ssa")
            }
          ]
        },
        {
          path: "/help",
          meta: {
            title: "Help"
          },
          component: RouterLayout,
          children: [
            {
              path: "language-support",
              component: () => import("./views/site/help/languageSupport")
            }
          ]
        },
        {
          path: "/blog",
          meta: {
            title: "Blog"
          },
          component: RouterLayout,
          children: [
            {
              path: "/",
              meta: {
                title: "Blog Reading List"
              },
              component: () => import("./views/site/blog")
            },
            {
              path: "article/:blogTitle",
              meta: {
                title: "Blog"
              },
              component: () => import("./views/site/blog/article")
            },
            {
              path: "a/:blogTitle",
              meta: {
                title: "Blog"
              },
              component: () => import("./views/site/blog/article")
            },
            {
              path: "crew",
              meta: {
                title: "Blog Crew"
              },
              component: () => import("./views/site/blog/crew")
            },
            {
              path: "/blog/crew/@:crewName",
              meta: {
                title: "Blog Crew Member"
              },
              component: () => import("./views/site/blog/crew/member")
            },
            {
              path: "list",
              meta: {
                title: "Blog Reading List"
              },
              component: () => import("./views/site/blog/list")
            },
            {
              path: "apply-to-blog",
              meta: {
                title: "Blog"
              },
              component: () => import("./views/site/blog/apply")
            }
          ]
        },
        {
          path: "/myapp",
          redirect: "/myapps",
          meta: {
            title: "MyApps Home"
          },
          component: RouterLayout,
          children: [
            {
              path: "/myapps",
              meta: {
                title: "MyApps"
              },
              component: () => import("./views/site/myApps")
            },
            {
              path: ":myAppName",
              meta: {
                title: "MyApps Title"
              },
              component: () => import("./views/site/myApps/myApp")
            },
            {
              path: "/@:myAppName",
              meta: {
                title: "Corner Title"
              },
              component: () => import("./views/site/myApps/myApp")
            },
            {
              path: "/@:myAppName/:heartbeatId",
              meta: {
                title: "Corner Title"
              },
              component: () =>
                import("./views/site/myApps/myAppDisplayHeartbeat")
            },
            {
              path: "c/:myAppName",
              meta: {
                title: "Corner Title"
              },
              component: () => import("./views/site/myApps/myApp")
            },
            {
              /* resource - pages, crew, */
              path: ":myAppName/:resource",
              meta: {
                title: "Blog"
              },
              component: () => import("./views/site/myApps/myApp")
            },
            {
              path: ":myAppName/:resource/:resourceItem",
              meta: {
                title: "The Specific Area"
              },
              component: () => import("./views/site/myApps/myApp")
            }
          ]
        },
        {
          path: "/sessions",
          redirect: "/sessions",
          meta: {
            title: "Sessions"
          },
          component: RouterLayout,
          children: [
            {
              path: "/sessions",
              meta: {
                title: "Online Sessions"
              },
              component: () => import("./views/site/sessions")
            },
            {
              path: ":cornerTitle",
              meta: {
                title: "Corner Title"
              },
              component: () => import("./views/site/sessions/session")
            },
            {
              path: "c/:cornerTitle",
              meta: {
                title: "Corner Title"
              },
              component: () => import("./views/site/sessions/session")
            },
            {
              /* resource - pages, crew, */
              path: ":cornerTitle/:resource",
              meta: {
                title: "Blog"
              },
              component: () => import("./views/site/sessions/session")
            },
            {
              path: ":cornerTitle/:resource/:resourceItem",
              meta: {
                title: "The Specific Area"
              },
              component: () => import("./views/site/sessions/session")
            }
          ]
        },
        {
          path: "/resource",
          redirect: "/resources",
          meta: {
            title: "Resources"
          },
          component: RouterLayout,
          children: [
            {
              path: "/resources",
              meta: {
                title: "Resources"
              },
              component: () => import("./views/site/resources")
            },
            {
              path: ":resourceName",
              meta: {
                title: "Resource"
              },
              component: () => import("./views/site/resources/corner")
            },
            {
              path: ":resourceName/download",
              meta: {
                title: "Resource"
              },
              component: () => import("./views/site/invites/corner")
            },
            {
              path: "r/:resource",
              meta: {
                title: "Free Resource"
              },
              component: () => import("./views/site/myApps/myApp")
            },
            {
              /* resource - pages, crew, */
              path: ":cornerTitle/:resource",
              meta: {
                title: "Blog"
              },
              component: () => import("./views/site/myApps/myApp")
            },
            {
              path: ":cornerTitle/:resource/:resourceItem",
              meta: {
                title: "The Specific Area"
              },
              component: () => import("./views/site/myApps/myApp")
            }
          ]
        },
        {
          path: "/invite",
          redirect: "/myapps",
          meta: {
            title: "Invitation"
          },
          component: RouterLayout,
          children: [
            {
              path: "/myapps",
              meta: {
                title: "Invitation"
              },
              component: () => import("./views/site/myApps")
            },
            {
              path: ":inviteCode",
              meta: {
                title: "Invitation"
              },
              component: () => import("./views/site/invites/corner")
            },
            {
              path: "c/:cornerTitle",
              meta: {
                title: "Corner Title"
              },
              component: () => import("./views/site/myApps/myApp")
            },
            {
              /* resource - pages, crew, */
              path: ":cornerTitle/:resource",
              meta: {
                title: "Blog"
              },
              component: () => import("./views/site/myApps/myApp")
            },
            {
              path: ":cornerTitle/:resource/:resourceItem",
              meta: {
                title: "The Specific Area"
              },
              component: () => import("./views/site/myApps/myApp")
            }
          ]
        },
        {
          path: "/crew",
          meta: {
            title: "Crew"
          },
          component: AuthLayout,
          children: [
            {
              path: "/",
              meta: {
                title: "Blog Reading List"
              },
              component: () => import("./views/site/crew")
            },
            {
              path: "@:typeId/@:guideId",
              meta: {
                title: "Blog Reading List"
              },
              component: () => import("./views/site/crew/guide")
            },
            {
              path: "@:guideId",
              meta: {
                title: "Book a Session"
              },
              component: () => import("./views/site/crew/guide")
            }
          ]
        },
        {
          path: "/feedback",
          component: () => import("./views/site/forms/feedback")
        },
        {
          path: "/system/404",
          meta: {
            title: "Error 404"
          },
          component: () => import("./views/site/system/404")
        },
        {
          path: "/system/500",
          meta: {
            title: "Error 500"
          },
          component: () => import("./views/site/system/500")
        }
      ]
    },
    {
      path: "/app",
      redirect: "/",
      component: AppLayout,
      meta: { authRequired: true, hidden: true },
      children: [
        {
          path: "/sessions",
          redirect: "sessions",
          component: SessionLayout,
          meta: { authRequired: true, hidden: true },
          children: [
            {
              path: "/sessions",
              meta: {
                title: "Sessions"
              },
              component: () => import("./views/app/sessions")
            }
          ]
        },
        {
          path: "/",
          meta: {
            title: "PonyEngine"
          },
          component: () => import("./views/app/myapps")
        },
        {
          path: "profile",
          meta: {
            title: "My Profile"
          },
          component: () => import("./views/app/me")
        },
        {
          path: "pricing",
          meta: {
            title: "PonyEngine pricingsans"
          },
          component: () => import("./views/site/pricing")
        },
        {
          path: "blog",
          meta: {
            title: "PonyEngine Blog"
          },
          component: () => import("./views/site/blog")
        },
        {
          path: "library",
          meta: {
            title: "PonyEngine Corners"
          },
          component: () => import("./views/site/myApps")
        },
        {
          path: "/manage",
          redirect: "corner",
          component: RouterLayout,
          children: [
            {
              path: "platform",
              meta: {
                title: "Publishing Platform",
                activeGuideRequired: true,
                hidden: true
              },
              component: () => import("./views/app/manage/platform")
            },
            {
              path: "blog",
              meta: {
                title: "Blog Management",
                activeBlogRequired: true,
                hidden: true
              },
              component: () => import("./views/app/manage/blogger")
            },
            {
              path: "admin",
              meta: {
                title: "Admin Management",
                activeAdminRequired: true,
                hidden: true
              },
              component: () => import("./views/app/manage/admin")
            }
          ]
        },
        {
          path: "/heartbeat",
          redirect: "/restricted",
          meta: {
            title: "My Heartbeats"
          },
          component: RouterLayout,
          async beforeRouteUpdate(to, from) {
            // react to route changes...
            this.userData = await fetchUser(to.params.id);
          },
          children: [
            {
              path: ":heartbeatSlug",
              meta: {
                title: "Heartbeat Title"
              },
              component: () => import("./views/app/heartbeat/index")
            },
            {
              path: "c/:cornerTitle",
              meta: {
                title: "Heartbeat Title"
              },
              component: () => import("./views/app/heartbeat")
            }
          ]
        }
      ]
    },
    {
      path: "/system",
      component: AuthLayout,
      redirect: "/signin",
      children: [
        {
          path: "/signin",
          meta: {
            title: "signin"
          },
          component: () => import("./views/site/signin")
        },
        {
          path: "/signup",
          meta: {
            title: "Sign Up"
          },
          component: () => import("./views/site/signup")
        },
        {
          path: "/forgot-password",
          meta: {
            title: "Forgot Password"
          },
          component: () => import("./views/site/forgotPassword")
        },
        {
          path: "/system/404",
          meta: {
            title: "Error 404"
          },
          component: () => import("./views/site/system/404")
        }
      ]
    },
    // Redirect to 404
    {
      path: "*",
      redirect: "system/404",
      hidden: true
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.authRequired)) {
    let isAuthenticated = localStorage.getItem("userData");
    // console.log("isAuthenticated => ", isAuthenticated);
    if (!isAuthenticated) {
      next({
        path: "/signin"
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
